module.exports = __webpack_public_path__ + "img/photo_240450750_1.08a98154.jpg";